const ctr = "center-center"
const ngxUiLoaderConfig: NgxUiLoaderConfig =
{
	"bgsColor": "red",
	"bgsOpacity": 0.5,
	"bgsPosition": "bottom-right",
	"bgsSize": 60,
	"bgsType": "ball-spin-clockwise",
	"blur": 5,
	"delay": 0,
	"fastFadeOut": true,
	"fgsColor": "red",
	"fgsPosition": ctr,
	"fgsSize": 60,
	"fgsType": "ball-spin-clockwise",
	"gap": 24,
	"logoPosition": ctr,
	"logoSize": 120,
	"logoUrl": "",
	"masterLoaderId": "master",
	"overlayBorderRadius": "0",
	"overlayColor": "rgba(40, 40, 40, 0.8)",
	"pbColor": "red",
	"pbDirection": "ltr",
	"pbThickness": 3,
	"hasProgressBar": true,
	"text": "",
	"textColor": "#FFFFFF",
	"textPosition": ctr,
	"maxTime": -1,
	"minTime": 300
};
import {InjectionToken , NgModule , provideAppInitializer ,inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './core/footer/footer.component';
import { HeaderComponent } from './core/header/header.component';
import { ToolbarComponent } from './core/toolbar/toolbar.component';

// for dropdowns, any animations in web etc
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// mat list,icon,menu
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { AgGridModule } from 'ag-grid-angular';
import { LiosNavbarComponent } from './core/lios-navbar/lios-navbar.component';
import { HomeComponent } from './pages/home/home.component';

//Msal
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { Constants } from './constants';
import { AddPalletDataComponent } from './core/dialogs/add-pallet-data/add-pallet-data.component';
import { AddShipmentsDataComponent } from './core/dialogs/add-shipments-data/add-shipments-data.component';
import { AddShipmentsDetailsComponent } from './core/dialogs/add-shipments-details/add-shipments-details.component';
import { AddTransportationEntryComponent } from './core/dialogs/add-transportation-entry/add-transportation-entry.component';
import { DeletePalletDialogComponent } from './core/dialogs/delete-dialog/delete-pallet-dialog.component';
import { EditShipmentsDataComponent } from './core/dialogs/edit-shipments-data/edit-shipments-data.component';
import { SummaryHistoryLogsComponent } from './core/dialogs/summary-history-logs/summary-history-logs.component';
import { TEAssignInvoiceComponent } from './core/dialogs/teassign-invoice/teassign-invoice.component';
import { BtnCellRendererAssignDetails } from './core/grid/btn-cell-render-assign-details';
import { BtnCellRendererDetailsDelete } from './core/grid/btn-cell-render-details-delete';
import { BtnCellRendererEditDelete } from './core/grid/btn-cell-render-edit-delete';

import { BtnCellRenderermasterGrid } from './core/grid/btn-cell-render-masterGrid';
import { GridRefreshComponent } from './core/grid/grid-refresh.component';
import { HeaderCheckboxComponent } from './core/grid/header-checkbox.component';
import { RowCheckboxComponent } from './core/grid/row-checkbox.component';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService, MSAL_INSTANCE } from './msal';
import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from './msal/constants';
import { MsalInterceptorConfig } from './msal/msal.interceptor.config';
import { ASNHistoryComponent } from './pages/asn/asn-history/asn-history.component';
import { ASNPalletTypesComponent } from './pages/asn/asn-pallet-types/asn-pallet-types.component';
import { ASNSummaryComponent } from './pages/asn/asn-summary/asn-summary.component';
import { SummaryDetailsComponent } from './pages/asn/asn-summary/summary-details/summary-details.component';
import { InvoicesComponent } from './pages/document-control/invoices/invoices.component';
import { ShipmentsDetailsComponent } from './pages/document-control/shipments/shipments-details/shipments-details.component';
import { ShipmentsComponent } from './pages/document-control/shipments/shipments.component';
import { TransportationEntryComponent } from './pages/document-control/transportation-entry/transportation-entry.component';
import { NotificationMessageComponent } from './pages/notification-message/notification-message.component';
import { ConstantsService } from './service/constants.service';
import { BtnCellRendererDetails } from './core/grid/btn-cell-render-details';
import { BtnCellRendererDeleteClipboard } from './core/grid/btn-cell-render-delete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TransportationEntryDetailsComponent } from './pages/document-control/transportation-entry/transportation-entry-details/transportation-entry-details.component';
import { LogsComponent } from './pages/logs/logs.component';
import { HistoryLogsComponent } from 'src/app/core/dialogs/history-logs/history-logs.component';
import { GridErrorWarningComponent } from './core/dialogs/grid-error-warning/grid-error-warning.component';
import { TooltipFieldComponent } from './core/dialogs/tooltip-field/tooltip-field.component';
import { FgaService } from './fga/fga.service';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { provideApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/cache';
import {
    MsalInterceptorConfiguration,
    MsalGuardConfiguration,
  } from '@azure/msal-angular';
  import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
  import { MasterDetailModule } from 'ag-grid-enterprise'; 
import { FgaModule } from './fga/fga.module';
import { BreadcrumbComponent } from './core/breadcrumb/breadcrumb.component';
  ModuleRegistry.registerModules([
    AllCommunityModule,
    MasterDetailModule
  ]);
export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication({
		auth: {
			clientId: environment.CLIENT_ID,
			authority: environment.TENANT_ID,
			redirectUri: environment.REDIRECT_URL
		}
	});
}


export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(
      environment.REDIRECT_URL,
      environment.SCOPES
    );
  
    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap,
    };
  }

  export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [...environment.SCOPES],
      },
      loginFailedRoute: '/unauthorized',
    };
  }

  export function initializeMsal(instance: IPublicClientApplication): () => Promise<void> {
    return () => instance.initialize();
}

export const FGA_API_ENDPOINT = new InjectionToken<string>('FGA_API_ENDPOINT');



@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        ToolbarComponent,
        FooterComponent,
        HomeComponent,
        LiosNavbarComponent,
        ASNSummaryComponent,
        ASNHistoryComponent,
        ASNPalletTypesComponent,
        AddShipmentsDataComponent,
        EditShipmentsDataComponent,
        AddShipmentsDetailsComponent,
        ShipmentsDetailsComponent,
        ShipmentsComponent,
        InvoicesComponent,
        TransportationEntryComponent,
        AddPalletDataComponent,
        BtnCellRendererAssignDetails,
        BtnCellRendererDetailsDelete,
        BtnCellRendererDetails,
        BtnCellRendererEditDelete,
        BtnCellRenderermasterGrid,
        BtnCellRendererDeleteClipboard,
        NotificationMessageComponent,
        DeletePalletDialogComponent,
        AddTransportationEntryComponent,
        SummaryDetailsComponent,
        SummaryHistoryLogsComponent,
        TEAssignInvoiceComponent,
        GridErrorWarningComponent,
        TransportationEntryDetailsComponent,
        LogsComponent,
        HistoryLogsComponent,
        TooltipFieldComponent, BtnCellRendererAssignDetails, BtnCellRendererEditDelete, BtnCellRendererDeleteClipboard,
        BtnCellRendererDetailsDelete, BtnCellRenderermasterGrid, BtnCellRendererDetails,
        RowCheckboxComponent, HeaderCheckboxComponent, TooltipFieldComponent,
        UnauthorizedComponent,
        GridRefreshComponent
    ],
    bootstrap: [AppComponent], imports: [MatTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        AppRoutingModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatDialogModule,
        MatTabsModule,
        BrowserAnimationsModule,
        AgGridModule,
        FgaModule,
        BreadcrumbComponent,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)], providers: [ConstantsService, Constants, DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        provideAppInitializer(() => {
            const msalInstance = inject(MSAL_INSTANCE);
            return msalInstance.initialize();
          }),
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService, provideHttpClient(withInterceptorsFromDi()),
        provideApollo(() => {
            return { cache: new InMemoryCache() }
          }),
        { provide: FGA_API_ENDPOINT, useValue: environment.APM_DS_URI }
    ] })
export class AppModule { }
